import { useMutation } from "@apollo/client/react";
import GET_USER_GROUPS from "../../queries/rolesAndPermissions/getUserGroups";
import { UPDATE_GROUP } from "../../mutations/rolesAndPermissions/updateGroup";
import GET_USER_GROUP from "../../queries/rolesAndPermissions/getUserGroup";

export const useUpdateGroup = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [updateGroup, { data, loading, error }] = useMutation(UPDATE_GROUP, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_USER_GROUPS, GET_USER_GROUP],
    awaitRefetchQueries: true,
  });

  return { updateGroup, data, loading, error };
};
